import React, { useRef } from 'react';
import { staticImageAssets } from 'js/constants/Paths';
import { useSFX } from 'js/hooks/useSFX';
const AnimationBluey = () => {
  const el = useRef(null);
  const { playSFX } = useSFX();

  React.useEffect(() => {
    setTimeout(() => {
      playSFX('giggle');
    }, 6000);
  }, []);

  return (
    <div className="animation__bluey">
      <div ref={el}>
        <img src={staticImageAssets('images/static/bluey.png')} />
      </div>
    </div>
  );
};

export default AnimationBluey;
